<template>
  <div class="mailBox"  @click="dblBtn" :style="{ height: clientHeight + 'px' }">
    <div class="configBtn" v-show="showBtn == true" @click.stop>
      <el-button type="info" @click="toConfig">修改配置</el-button>
    </div>
    <selectCheck></selectCheck>
    <btnCancel></btnCancel>
  </div>
</template>

<script>
import selectCheck from './selectCheck.vue'
import btnCancel from './common/btnCancel.vue'
import { storage } from '../../../static/js/utils/utility'
import { getCompanyInfo } from '../../../static/mailBox/js/request'
// 全局this指向
var _this
export default {
  name:'mailBox',

  components: {
    btnCancel,
    selectCheck,
  },

  data() {
    return {
      num: 0, // 点击次数
      time: '', 
      showBtn: false,
      clientHeight: '',
      hasBackIndex: '',
      // type: this.$store.state.mail_type,
    }
  },

  created() {
    console.log('设备号：', storage.localGetItem('device_no_id'))
    console.log('用户选择的业务类型：', this.$store.state.mail_oType)
    console.log('用户的身份：', this.$store.state.mail_type)
    this.getCompanyInfo(storage.localGetItem('device_no_id'))
  },

   mounted () {
    this.clientHeight = window.screen.availHeight
    this.hasBackIndex = (document.getElementsByClassName('back-index')[0] !== undefined)
    if (document.getElementsByClassName('back-index')[0] !== undefined) {
      this.btnText = '返回首页'
    } else {
      this.btnText = '取消操作'
    }
    // 计算html的font-size
    window.onresize = function () {
      // 监听屏幕变化
      getRem(1920, 100)
    }
    function getRem (pwidth, prem) {
      const html = document.getElementsByTagName('html')[0]
      const oWidth = document.body.clientWidth || document.documentElement.clientWidth
      // console.log('oWidth', oWidth)
      html.style.fontSize = oWidth / pwidth * prem + 'px'
    }
    getRem(1920, 100)
  },

  watch: {
    // '$store.state.mail_type': function (newVal) {
    //   this.type = newVal
    // }
  },

  methods: {
    // 跳转到配置页
    toConfig() {
      this.$router.push({
        path: '/CConfigSetting',
        query: {
          'project': true,
        }
      })
    },

    // 连续点击屏幕5次
    dblBtn() {
      var that = this;
      this.num++
      if(this.num == 1) {
        that.timer1 = new Date().getTime()/1000
      }
      if(this.num == 5) {
        this.timer4= new Date().getTime()/1000
        if(that.timer4 - that.timer1 <= 2) {
          that.num = 0
          that.showBtn = true
          setTimeout(function() {
            that.showBtn = false
          }, 5000);
        } else {
          this.num = 0
        }
      }
    },

    // 获取公司信息
    getCompanyInfo: async function(device_no_id) {
      let vm = this
      let data = {'device_no_id': device_no_id}
      let res = await getCompanyInfo(data)
      console.info('公司信息：', res)
      if (res.meta.code == 200) {
        // vm.$store.state.company_ic = res.data.company_ic
        // vm.$store.state.company_id = res.data.company_id
        // vm.$store.state.server_address = res.data.server_address
        vm.$store.commit('company_ic', res.data.company_ic)
        vm.$store.commit('company_id', res.data.company_id)
        vm.$store.commit('server_address', res.data.server_address)
      } else {
        console.warn(res)
      }
    }
  }
}
</script>

<style lang="less">
.mailBox {
  height: 100vh;
  width: 100%;
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ffffff;
  background:  url(/static/images/bg.jpg) center no-repeat;
  background-size: 100% 100%;
  position: fixed;
  top: 0;
  right: 0;
  .configBtn {
    position: absolute;
    right: 0.94rem;
    top: 0.47rem;
    z-index: 99;
    .el-button {
      height: 0.94rem;
      // width: 2.54rem;
      padding: 0 0.6rem;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height: 0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .explain{
    font-size: 0.34rem;
    color: #999999;
    position: absolute;
    right: 0.5rem;
    bottom: 0.4rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/mailBox/mailBox.vue